import React, { useEffect, useState } from "react";
import "./ActivityStatus.css";
import { getChangeStatusById } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";

const ActivityStatusPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [transationId, setTransactionId] = useState("");
  const token = useSelector((state) => state.userReducer.token);

  const fetchChangeStatusReport = async (currentPage,transationId) => {
    try {
      setLoading(true);
      const response = await getChangeStatusById(
        token,
        transationId,
        currentPage
      );
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };
  useEffect(() => {
    if(transationId !== ''){

      const delayDebounce = setTimeout(() => {
        fetchChangeStatusReport(1,transationId);
      }, 2000); 
      return () => clearTimeout(delayDebounce);
    }
  }, [transationId]);

  useEffect(() => {
    if (transationId === "") {
      fetchChangeStatusReport(currentPage, "");
    }
  }, [currentPage,transationId]);

  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };

  return (
    <div className="activity-status-table-container">
      <div className="activity-status-heading">
        <h2 className="activity-status-table-title">Change Status Report</h2>
        <input
          className="activity-input-field-container"
          type="text"
          placeholder="Order ID"
          value={transationId}
          onChange={handleTransactionIdChange}
        />
      </div>
      <table className="activity-table">
        <thead>
          <tr>
            <th>Merchant Name</th>
            <th>PG</th>
            <th>Type</th>
            <th>Amount(₹)</th>
            <th>Status</th>
            <th>Order Id</th>
            <th>Transaction Id</th>
            <th>Changed By</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="9">Loading...</td>
            </tr>
          ) : statusData?.length > 0 ? (
            statusData.map((item, index) => {
              const isLogs = !!item.logs;
              const dynamicKey = isLogs
                ? Object.keys(item.logs)[0]
                : Object.keys(item).find(
                    (key) =>
                      key !== "_id" &&
                      key !== "createdAt" &&
                      key !== "updatedAt" &&
                      key !== "__v"
                  );
              const logData = isLogs ? item.logs[dynamicKey] : item[dynamicKey];

              return (
                <tr key={index}>
                  <td>{logData?.alias ? logData?.alias:logData?.userId || "N/A"}</td>
                  <td>{logData?.pg || "N/A"}</td>
                  <td>{logData?.type || "N/A"}</td>
                  <td>{logData?.amount || "N/A"}</td>
                  <td>{logData?.status || "N/A"}</td>
                  <td
                    className="cursor-pointer"
                    data-tooltip-id="tooltip-order"
                    data-tooltip-content={dynamicKey}
                    onClick={() => {
                      navigator.clipboard.writeText(dynamicKey);
                      toast.success("Order ID copied successfully.");
                    }}
                  >
                    {dynamicKey?.slice(0, 10)}...
                  </td>
                  <td
                    className="cursor-pointer"
                    data-tooltip-id="tooltip-transaction"
                    data-tooltip-content={logData?.transactionId}
                    onClick={() => {
                      navigator.clipboard.writeText(
                        logData?.transactionId || ""
                      );
                      toast.success("Transaction ID copied successfully.");
                    }}
                  >
                    {logData?.transactionId?.slice(0, 10)}...
                  </td>
                  <td>{logData?.changedBy || "N/A"}</td>
                  <td>
                    {new Date(item?.updatedAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <Tooltip id="tooltip-order" place="top" />
      <Tooltip id="tooltip-transaction" place="top" />
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default ActivityStatusPage;
